import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const FeedbackEmotionScale1 = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M16 30C8.28 30 2 23.72 2 16C2 8.28 8.28 2 16 2C23.72 2 30 8.28 30 16C30 23.72 23.72 30 16 30ZM16 4C9.383 4 4 9.383 4 16C4 22.617 9.383 28 16 28C22.617 28 28 22.617 28 16C28 9.383 22.617 4 16 4Z" />
		<path d="M9.00001 22C9.39001 22 9.72601 21.776 9.89201 21.451C9.89201 21.451 11.711 18 16 18C20.28 18 22.108 21.45 22.108 21.45C22.273 21.776 22.61 22 23 22C23.552 22 24 21.552 24 21C24 20.839 23.961 20.688 23.894 20.553C23.894 20.553 23.877 20.519 23.873 20.512C23.631 20.071 21.254 16 16.001 16C10.748 16 8.37101 20.071 8.12901 20.512C8.12501 20.52 8.10801 20.553 8.10801 20.553C8.04101 20.687 8.00201 20.839 8.00201 21C8.00201 21.552 8.45001 22 9.00201 22H9.00001Z" />
		<path d="M23 10C19.548 10 18.251 12.283 18.135 12.5C18.05 12.647 18 12.818 18 13C18 13.552 18.448 14 19 14C19.392 14 19.73 13.774 19.894 13.447C19.894 13.447 20.625 12 23 12C23.552 12 24 11.552 24 11C24 10.448 23.552 10 23 10V10Z" />
		<path d="M9 10C12.452 10 13.749 12.283 13.865 12.5C13.95 12.647 14 12.818 14 13C14 13.552 13.552 14 13 14C12.608 14 12.271 13.774 12.106 13.447C12.106 13.447 11.375 12 9 12C8.448 12 8 11.552 8 11C8 10.448 8.448 10 9 10Z" />
	</svg>
);

export default FeedbackEmotionScale1;
